export const RESOURCE_ENDPOINT = '/ai-search/convergence'
